import { cn } from "@/lib/utils";
import React from "react";

const badgeVariants = {
  default: "bg-bambu-green/10 text-bambu-green hover:bg-bambu-green/20",
  secondary: "bg-bambu-gray-light text-bambu-black hover:bg-gray-200",
  outline: "text-bambu-black border border-bambu-green",
  destructive: "bg-bambu-red/10 text-bambu-red hover:bg-bambu-red/20",
  hashtag: "bg-bambu-green-light-2/30 text-bambu-dark-green font-bold",
};

export function Badge({ className, variant = "default", children, ...props }) {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 font-montserrat",
        badgeVariants[variant],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
